import { router } from '@inertiajs/react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HistoryIcon from '@mui/icons-material/History';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { DataGrid } from '@mui/x-data-grid';
import { ptBR } from '@mui/x-data-grid/locales';
import * as React from 'react';
import DriveSyncLayout from '../../layouts/DriveSyncLayout';
import TowerHeader from './TowerHeader';

// Helper function to get cached user name
const cachedUserName = (userId, userName) => {
  // If we have the user name directly, use it
  if (userName) return userName;

  // Otherwise, fallback to user ID or System
  if (!userId) return 'Sistema';
  return `Usuário ${userId}`;
};

const columns = [
  {
    field: 'created_at',
    headerName: 'Data da Alteração',
    flex: 1,
    minWidth: 150,
    renderCell: (params) => {
      return new Date(params.value).toLocaleString('pt-BR');
    }
  },
  {
    field: 'event',
    headerName: 'Evento',
    flex: 0.8,
    minWidth: 100,
    renderCell: (params) => {
      return params.value === 'update' ? 'Atualização' : 'Exclusão';
    }
  },
  {
    field: 'whodunnit',
    headerName: 'Alterado por',
    flex: 1,
    minWidth: 120,
    renderCell: (params) => {
      return cachedUserName(params.value, params.row.user_name);
    }
  },
  {
    field: 'changeset',
    headerName: 'Alterações',
    flex: 2,
    minWidth: 200,
    renderCell: (params) => {
      const changeset = params.value || {};

      return (
        <Box sx={{ whiteSpace: 'pre-wrap' }}>
          {changeset.join('\n')}
        </Box>
      );
    }
  }
];

export default function Show({ trip }) {
  const handleBack = () => {
    router.visit('/towers');
  };

  return (
    <DriveSyncLayout>
      <TowerHeader />

      <Box sx={{
        width: '100%',
        maxWidth: { sm: '100%', md: '800px' },
        mx: 'auto',
        mt: 2
      }}>
        {/* Header */}
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
          <IconButton onClick={handleBack} sx={{ mr: 2 }} size="small">
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h4" component="h1">
            Detalhes da Viagem
          </Typography>
        </Box>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          Histórico de alterações para {trip.carrier_name} - {trip.user_name} (#{trip.sequence_indicator})
        </Typography>

        {/* Trip Details Card */}
        <Card elevation={2} sx={{ mb: 3 }}>
          <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
              <HistoryIcon color="primary" />
              <Typography variant="h6">
                Histórico de Alterações
              </Typography>
            </Box>

            <Box sx={{ height: 600, width: '100%' }}>
              <DataGrid
                localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                rows={trip.versions || []}
                columns={columns}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                }
                initialState={{
                  pagination: { paginationModel: { pageSize: 25 } },
                }}
                pageSizeOptions={[10, 25, 50, 100]}
                density="compact"
                disableSelectionOnClick
                slotProps={{
                  filterPanel: {
                    filterFormProps: {
                      logicOperatorInputProps: {
                        variant: 'outlined',
                        size: 'small',
                      },
                      columnInputProps: {
                        variant: 'outlined',
                        size: 'small',
                        sx: { mt: 'auto' },
                      },
                      operatorInputProps: {
                        variant: 'outlined',
                        size: 'small',
                        sx: { mt: 'auto' },
                      },
                      valueInputProps: {
                        InputComponentProps: {
                          variant: 'outlined',
                          size: 'small',
                        },
                      },
                    },
                  },
                }}
              />
            </Box>
          </CardContent>
        </Card>
      </Box>
    </DriveSyncLayout>
  );
} 